export class Analytics {
  static track(eventName: string, eventProperties?: object) {
    const eventProperties2 = eventProperties === undefined ? {} : eventProperties;

    if (((window as any).mixpanel as boolean) && ((window as any).mixpanel.track as boolean)) {
      mixpanel.track(
        eventName,
        eventProperties2,
        () => {
          // Do Nothing
        },
        () => {
          // Do Nothing
        }
      );
    }
  }
}
